import React, { useEffect, useState } from "react";
import axiosInstance from "../../../global/common/interceptor";
import apiService from "../../../global/common/environment";
import { FaEye } from "react-icons/fa";
import "./Payments.scss";

const Payments = () => {
  const [payments, setPayments] = useState([]);
  const [filteredPayments, setFilteredPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [modalData, setModalData] = useState(null);
  const [modalLoading, setModalLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const paymentsPerPage = 10;

  useEffect(() => {
    const fetchPayments = async () => {
      try {
        const response = await axiosInstance.get(apiService.getpayments({ page: 1, limit: 100 }));
        const paymentsData = Array.isArray(response.data.payments) ? response.data.payments : [];
        setPayments(paymentsData);
        setFilteredPayments(paymentsData);
      } catch (err) {
        console.error(err);
        setError("Failed to fetch payments data");
      } finally {
        setLoading(false);
      }
    };
    fetchPayments();
  }, []);

  useEffect(() => {
    const filteredData = payments.filter(
      (payment) =>
        payment.firstname?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        payment.productinfo?.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredPayments(filteredData);
  }, [searchQuery, payments]);

  const fetchTransactionDetails = async (transactionId) => {
    setModalLoading(true);
    try {
      const response = await axiosInstance.get(apiService.getPaymentTransactionById(transactionId));
      setModalData(response.data);
    } catch (err) {
      console.error(err);
      setError("Failed to fetch transaction details");
    } finally {
      setModalLoading(false);
    }
  };

  const closeModal = () => setModalData(null);

  const indexOfLastPayment = currentPage * paymentsPerPage;
  const indexOfFirstPayment = indexOfLastPayment - paymentsPerPage;
  const currentPayments = filteredPayments.slice(indexOfFirstPayment, indexOfLastPayment);
  
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const totalPages = Math.ceil(filteredPayments.length / paymentsPerPage);

  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  if (loading) return <p>Loading payments...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div className="payments-container">
      <h1>User Payments</h1>
      <div className="search-container">
        <input
          type="text"
          placeholder="Search by Name or Product..."
          className="search-input"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>
      <table>
        <thead>
          <tr>
            <th>S.No</th>
            <th>First Name</th>
            <th>Transaction ID</th>
            <th>Phone</th>
            <th>Email</th>
            <th>Total Amount</th>
            <th>Product</th>
            <th>Status</th>
            <th>Items</th>
            <th>View</th>
          </tr>
        </thead>
        <tbody>
          {currentPayments.map((payment, index) => (
            <tr key={payment._id}>
              <td>{indexOfFirstPayment + index + 1}</td>
              <td>{payment.firstname || "N/A"}</td>
              <td>{payment.txnid || "N/A"}</td>
              <td>{payment.phone || "N/A"}</td>
              <td>{payment.email || "N/A"}</td>
              <td>{payment.amount || "N/A"}</td>
              <td>{payment.productinfo || "N/A"}</td>
              <td>{payment.status || "N/A"}</td>
              <td>
                <ul>
                  {payment.items && payment.items.length > 0 ? (
                    payment.items.map((item) => (
                      <li key={item._id}>Course ID: {item.courseId}, Price: {item.price}</li>
                    ))
                  ) : (
                    <li>No items</li>
                  )}
                </ul>
              </td>
              <td>
                <FaEye className="view-icon" onClick={() => fetchTransactionDetails(payment.mihpayid)} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="pagination">
        <button onClick={prevPage} disabled={currentPage === 1}>&laquo; Prev</button>
        {Array.from({ length: totalPages }, (_, i) => (
          <button key={i + 1} onClick={() => paginate(i + 1)} className={currentPage === i + 1 ? "active" : ""}>
            {i + 1}
          </button>
        ))}
        <button onClick={nextPage} disabled={currentPage === totalPages}>Next &raquo;</button>
      </div>

      {modalData && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <span className="close-icon" onClick={closeModal}>&times;</span>
            <div className="modal-body">
              <h2>Transaction Details</h2>
              {modalLoading ? (
                <p>Loading transaction details...</p>
              ) : (
                <>
                  <p><strong>Name:</strong> {modalData.firstname || "N/A"}</p>
                  <p><strong>Transaction ID:</strong> {modalData.txnid || "N/A"}</p>
                  <p><strong>Email:</strong> {modalData.email || "N/A"}</p>
                  <p><strong>Phone:</strong> {modalData.phone || "N/A"}</p>
                  <p><strong>Amount:</strong> {modalData.amount || "N/A"}</p>
                  <p><strong>Currency:</strong> {modalData.currency || "N/A"}</p>
                  <p><strong>Status:</strong> {modalData.status || "N/A"}</p>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Payments;
